import { render, staticRenderFns } from "./DashboardPortlet.vue?vue&type=template&id=6607ee85&scoped=true"
import script from "./DashboardPortlet.vue?vue&type=script&lang=js"
export * from "./DashboardPortlet.vue?vue&type=script&lang=js"
import style0 from "./DashboardPortlet.vue?vue&type=style&index=0&id=6607ee85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6607ee85",
  null
  
)

export default component.exports